import React from "react";

import ForgotPasswordLayout from "../../components/universal/forgot-password-layout";
import ForgotPasswordContent from "../../components/public/forgot-password";

import { Helmet } from "react-helmet-async";

const ForgotPasswordPage = () => {
  return (
    <>
      <Helmet>
        <title>Leadfind - Glemt passord</title>
        <meta name="thumbnail" content="https://leadfind.no/showcase.jpg" />
        <meta name="robots" content="index, follow" />
        <meta
          name="description"
          content="Dersom du har glemt passordet eller mistet tilgang til din Leadfind-konto kan du tilbakestille det på denne siden."
        />
        <meta name="author" content="Leadfind" />
        <meta
          name="keywords"
          content="prospecting, salgsverktøy, salg, nye kunder, crm"
        />

        <meta name="twitter:card" content="summary" />
        <meta name="twitter:url" content="https://leadfind.no/glemt-passord" />
        <meta name="twitter:title" content="Leadfind - Glemt passord" />
        <meta
          name="twitter:description"
          content="Dersom du har glemt passordet eller mistet tilgang til din Leadfind-konto kan du tilbakestille det på denne siden."
        />
        <meta name="twitter:image" content="https://leadfind.no/showcase.jpg" />

        <meta property="og:url" content="https://leadfind.no/glemt-passord" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Leadfind - Glemt passord" />
        <meta
          property="og:description"
          content="Dersom du har glemt passordet eller mistet tilgang til din Leadfind-konto kan du tilbakestille det på denne siden."
        />
        <meta property="og:image" content="https://leadfind.no/showcase.jpg" />
        <link rel="canonical" href="https://leadfind.no/glemt-passord" />
      </Helmet>
      <ForgotPasswordLayout Content={() => <ForgotPasswordContent />} />
    </>
  );
};

export default ForgotPasswordPage;
